import React, { useRef } from "react";
import Button from "@mui/material/Button";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

export const UploadFile = (props = {}) => {
  const inputRef = useRef(null);

  const handleCaptureImage = ({ target }) => {
    const fileReader = new FileReader();
    const isValid = target.accept.includes("image");
    if (isValid && target.files.length) {
      const file = target.files[0];
      fileReader.readAsDataURL(file);
      fileReader.onload = (event) => {
        const url = event.currentTarget.result;
        props.onPreview({ url, file, input: target });
      };
    } else {
      props.onInvalidFile();
    }
  };

  const handleUploadFile = () => {
    inputRef.current.click();
  };

  return (
    <>
      <Button
        onClick={handleUploadFile}
        variant="contained"
        sx={{
          width: "100%",
          backgroundColor: props.color,
          borderRadius: 0,
          height: "50px",
          fontSize: "12px",
        }}
        endIcon={<CloudUploadIcon />}
      >
        {props.labels.uploadFile}
      </Button>
      <input
        ref={inputRef}
        onChange={handleCaptureImage}
        accept="image/*"
        type="file"
        hidden
      />
    </>
  );
};
